<template>
    <div class="Notice">
        <el-dialog
            title="商城公告"
            :visible.sync="NoticeVisible"
            :close-on-click-modal="false"
            width="540px"
            center>
            <div class="dialogBox">
                <div class="tip">温馨提示：警惕积分诈骗电话，保护好个人信息安全</div>
                <div class="dialogBox_con">
                    <div class="dialogBox_con_ZC">尊敬的用户：</div>
                    <div class="dialogBox_con_content">近期出现部分积分诈骗电话，骗子用各种诈骗理由骗取您的服务密码和验证码，从而消耗您的积分。在此提醒您：斯坦德检测不会以任何形式索要您的密码及验证码，请您不要向他人透露个人手机密码、验证码等个人信息，确保个人信息安全。</div>
                </div>
                <div class="dialogBox_con_right">斯坦德检测积分商城</div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="NoticeVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'Notice',
    data() {
        return {
            NoticeVisible: false
        }
    },
    methods: {
        open() {
            this.NoticeVisible = true;
        }
    }
}
</script>

<style scoped>
.Notice /deep/ .el-dialog__header {
    font-weight: 600;
}
.Notice /deep/ .el-dialog--center .el-dialog__body {
    padding: 10px 20px;
}
.Notice /deep/ .el-dialog__body .dialogBox {
    min-height: 360px;
    max-height: 440px;
    overflow: hidden;
    background: #f7f7f7;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.Notice /deep/ .el-dialog__body .dialogBox .tip {
    font-size: 14px;
    text-align: center;
}
.Notice /deep/ .el-dialog__body .dialogBox .dialogBox_con {
    font-size: 14px;
    text-align: left;
    line-height: 28px;
}
.Notice /deep/ .el-dialog__body .dialogBox .dialogBox_con_content {
    text-indent: 28px;
}
.Notice /deep/ .el-dialog__body .dialogBox .dialogBox_con_right {
    text-align: right;
}
</style>